module.exports = __webpack_public_path__ + "img/collection-engagementRings025Carat@2x.da1c314.webp";